//该文件专门用于创建整个应用的路由器
import Vue from 'vue'
import VueRouter from 'vue-router'
import loginPage from '../components/loginPage.vue'
import HelloWorld from '../components/HelloWorld.vue'
import GameHome from '../components/GameHome.vue'
import AccountManage from '../components/AccountManage.vue'
import GameInfo from '../components/GameInfo.vue'
import TrafficMasterData from '../components/TrafficMasterData.vue'
import MiniAppRealtime from '../components/MiniAppRealtime.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login'  // 将根路径重定向到登录页
    },
    {
        path: '/login',
        name: 'login',
        component: loginPage
    },
    {
        path: '/HelloWorld',
        name: 'HelloWorld',
        component: GameHome
    },
    {
        path: '/game-detail',
        name: 'GameDetail',
        component: HelloWorld
    },
    {
        path: '/account-manage',
        name: 'AccountManage',
        component: AccountManage
    },
    {
        path: '/game-info/:username',
        name: 'GameInfo',
        component: GameInfo
    },
    {
        path: '/traffic-master-data',
        name: 'TrafficMasterData',
        component: TrafficMasterData
    },
    {
        path: '/mini-app-realtime',
        name: 'MiniAppRealtime',
        component: MiniAppRealtime
    },
]

const router = new VueRouter({
    routes
})

// 路由守卫
// router.beforeEach((to, from, next) => {
//     const token = localStorage.getItem('token')
//     if (to.path === '/login') {
//         if (token) {
//             next('/HelloWorld')  // 如果已登录，跳转到首页
//         } else {
//             next()
//         }
//     } else {
//         if (token) {
//             next()
//         } else {
//             next('/login')
//         }
//     }
// })

export default router
